export enum DateUtil {
  DisplayFormat = 'eee, d MMM yyyy',
  IsoDateFormat = 'yyyy-MM-dd',
  DobFormat = 'd MMM yyyy',
  DobErrorFormat = 'MMM d, yyyy',
}
